/** Shopify CDN: Minification failed

Line 44:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 46:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 50:11 Transforming let to the configured target environment ("es5") is not supported yet
Line 51:8 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 34:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 35:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 36:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 37:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 40:11 Transforming let to the configured target environment ("es5") is not supported yet
Line 41:8 Transforming let to the configured target environment ("es5") is not supported yet

**/

/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:getShopifyProductData:complete',function(event){
    var data = event.detail;  
    var itemDom = data.item;
    var pro_handle = data.handle
    Flits(itemDom).find(".flits-view-product-link").attr("href","/products/" + pro_handle);  
  });


  Flits(document).on('click', '.flits-reorder-btn', function(event) {

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    let items = flitsOrder[Flits(this).attr('data-flits-target')];
    let params = {};
    let noItem = 0;
    let soldOutItem = 0;
    if (params.items = [],
        items.length > 0) {
      for (let i = 0; items.length > i; i++) {
        let item = items[i];
        item.item_variant_id ? item.available == 'true' ? (parseInt(item.inventory_quantity) <= parseInt(item.quantity) ? cartOrder[item.variant_id] && (parseInt(item.inventory_quantity) > parseInt(cartOrder[item.variant_id].cart_quantity) ? item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity) : item.quantity = parseInt(item.inventory_quantity),
                    flitsSnackbar.show({
          text: Flits.t('Flits.locals.general.cart_updated', 'Some items are no longer available. Your cart has been updated.'),
          pos: 'bottom-center',
          showAction: !1,
          customClass: 'flits-alert-default'
        })) : cartOrder[item.variant_id] && parseInt(item.inventory_quantity) <= parseInt(cartOrder[item.variant_id].cart_quantity) + parseInt(item.quantity) && (item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity),
                    flitsSnackbar.show({
          text: Flits.t('Flits.locals.general.cart_updated', 'Some items are no longer available. Your cart has been updated.'),
          pos: 'bottom-center',
          showAction: !1,
          customClass: 'flits-alert-default'
        })),
                                                           params.items.push({
          id: item.variant_id,
          quantity: item.quantity,
          properties:item.properties
        })) : soldOutItem++ : noItem++;
      }
      noItem == 1 ? flitsSnackbar.show({
        text: Flits.t('Flits.locals.order_page.one_product_unavailable', 'One of the products is unavailable'),
        pos: 'bottom-center',
        showAction: !1,
        customClass: 'flits-alert-default'
      }) : noItem > 1 && flitsSnackbar.show({
        text: Flits.t('Flits.locals.order_page.some_products_unavailable', 'Some of the products are unavailable'),
        pos: 'bottom-center',
        showAction: !1,
        customClass: 'flits-alert-default'
      }),
        soldOutItem == 1 ? setTimeout(function() {
        flitsSnackbar.show({
          text: Flits.t('Flits.locals.order_page.one_product_sold_out', 'One of the products is sold out.'),
          pos: 'bottom-center',
          showAction: !1,
          customClass: 'flits-alert-default'
        });
      }, noItem > 0 ? 1500 : 0) : soldOutItem > 1 && setTimeout(function() {
        flitsSnackbar.show({
          text: Flits.t('Flits.locals.order_page.some_products_sold_out', 'Some of the products are sold out'),
          pos: 'bottom-center',
          showAction: !1,
          customClass: 'flits-alert-default'
        });
      }, noItem > 0 ? 1500 : 0),
        Flits.dispatchEvent('Flits:order:BeforeReOrder', {
        params: params
      }),
        setTimeout(function() {
        Flits.addToCart(params);
      }, soldOutItem > 0 || noItem > 0 ? 2500 : 1000);
    }
  });
}(Flits));
